<template>
  <svg
    width="9"
    height="8"
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
   data-testid="assets-icon-arrow-success-svg">
    <path
      d="M8.04669 0.750055L4.52613 5.88751C3.93442 6.75098 2.66259 6.75819 2.06113 5.90148L0.749789 4.03366"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
    data-testid="assets-icon-arrow-success-path" />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: 'currentColor'
  },
  strokeWidth: {
    type: Number,
    default: 1.5
  }
})
</script>
